import React, { useState } from "react";
import Collapse from "@material-ui/core/Collapse";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { cx } from "../utils";

/**
 * CcHistorySection — collapsible context-panel block (revision / evaluation history).
 */
const CcHistorySection = ({
  title,
  count = 0,
  countUnit = "item",
  countUnitPlural,
  icon,
  defaultExpanded = true,
  emptyMessage,
  children,
  className,
  headerClassName,
  onExpandedChange,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const plural = countUnitPlural || `${countUnit}s`;
  const countLabel = `${count} ${count === 1 ? countUnit : plural}`;

  const toggle = () => {
    const next = !expanded;
    setExpanded(next);
    onExpandedChange?.(next);
  };

  return (
    <section className={cx("cc-history-section", className)}>
      <button
        type="button"
        className={cx("cc-history-section__header", headerClassName)}
        onClick={toggle}
        aria-expanded={expanded}
      >
        <span className="cc-history-section__header-main">
          {icon ? (
            <span className="cc-history-section__icon" aria-hidden>
              {icon}
            </span>
          ) : null}
          <span className="cc-history-section__title">{title}</span>
          <span className="cc-history-section__count">{countLabel}</span>
        </span>
        <span className="cc-history-section__chevron-wrap" aria-hidden>
          {expanded ? (
            <ExpandLessIcon className="cc-history-section__chevron" />
          ) : (
            <ExpandMoreIcon className="cc-history-section__chevron" />
          )}
        </span>
      </button>

      <Collapse in={expanded}>
        <div className="cc-history-section__body">
          {count === 0 && emptyMessage ? (
            <p className="cc-history-section__empty">{emptyMessage}</p>
          ) : (
            children
          )}
        </div>
      </Collapse>
    </section>
  );
};

export default CcHistorySection;
